"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var colors_1 = require("./util/colors");
var vf_config_manager_1 = require("./util/vf-config-manager");
var vf_ego_camera_1 = require("./vf-ego-camera");
var vf_event_trigger_1 = require("./vf-event-trigger");
var vf_trigger_factory_1 = require("./vf-trigger-factory");
var const_1 = require("./util/const");
var vf_trigger_meta_1 = require("./interfaces/vf-trigger-meta");
var vf_tools_1 = require("./util/vf-tools");
var logger_1 = require("./util/logger");
var vf_scene_state_1 = require("./enums/vf-scene-state");
var vf_external_texture_1 = require("./vf-external-texture");
var vf_material_1 = require("./vf-material");
var vf_object_1 = require("./vf-object");
var vf_asset_loader_1 = require("./util/vf-asset-loader");
var vf_model_dimension_1 = require("./vf-model-dimension");
var vf_material_factory_1 = require("./util/vf-material-factory");
var async_wait_until_1 = require("async-wait-until");
var babylonjs_2 = require("babylonjs");
var vector_functions_1 = require("./util/vector-functions");
var VFScene = (function (_super) {
    __extends(VFScene, _super);
    function VFScene(player) {
        var _this = _super.call(this, player.engine) || this;
        _this.player = player;
        _this._hoveredTrigger = null;
        _this.willStillLoadEnvironment = false;
        _this.sceneIsReady = false;
        _this.materialsAreFrozen = false;
        _this.texturesToLoad = 0;
        _this.onEgoInitCallbacks = [];
        _this.onEgoExitCallbacks = [];
        _this.onTriggerActivateCallbacks = [];
        _this.onTriggerHoverCallbacks = [];
        _this._materialsByName = {};
        _this._materialsByHash = {};
        _this._obectsByPath = {};
        _this.onClickTriggerObservable = new babylonjs_1.Observable();
        _this._offset = new babylonjs_1.Vector3();
        _this._rotate = new babylonjs_1.Vector3();
        _this.clearColor = colors_1.parseColorRGBA(vf_config_manager_1.default.GetConfig().sceneClearColor);
        _this.ambientColor = colors_1.parseColorRGB(vf_config_manager_1.default.GetConfig().ambientLightColor);
        _this.state = vf_scene_state_1.VFSceneState.Default;
        return _this;
    }
    Object.defineProperty(VFScene.prototype, "playerConfig", {
        get: function () {
            return this.player.config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFScene.prototype, "isAuraScene", {
        get: function () {
            return this._isAuraScene;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFScene.prototype, "root", {
        get: function () {
            return this.model.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFScene.prototype, "contentRoot", {
        get: function () {
            return this.model.getContentRoot();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VFScene.prototype, "hoveredTrigger", {
        get: function () {
            return this._hoveredTrigger;
        },
        enumerable: true,
        configurable: true
    });
    VFScene.prototype.addDimensionalMeasurement = function () {
        this.dimensionalMeasurements = new vf_model_dimension_1.default(this.model, this, this.player.config.dimensioningType);
    };
    VFScene.prototype.didActivateTrigger = function (triggerType, triggerId) {
        var e_1, _a;
        try {
            for (var _b = __values(this.onTriggerActivateCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var callback = _c.value;
                callback(triggerType, triggerId);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    VFScene.prototype.didHoverTrigger = function (triggerType, triggerId) {
        var e_2, _a;
        try {
            for (var _b = __values(this.onTriggerHoverCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var callback = _c.value;
                callback(triggerType, triggerId);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    VFScene.prototype.setModel = function (model, modelMeta) {
        var _this = this;
        this.name = model.name;
        this.texturesToLoad = 0;
        this.unfreeze();
        this.clearMeshes();
        if (this.player.expectsAuraWebFile) {
            this.normalizeModelTransform();
            model.scaleToBounds();
            this.translateSceneOriginToNodePosition("surrogateRoot");
            this._isAuraScene = true;
        }
        else {
            this._isAuraScene = false;
            model.scaleToSize(const_1.default.BASE_SCALE);
            model.setOrigin(babylonjs_1.Vector3.Zero());
        }
        this.model = model;
        var requiredCameraZ = this.model.largestSize * 1.5;
        if (this.camera.maxZ < requiredCameraZ) {
            this.camera.maxZ = requiredCameraZ;
        }
        this.light.shadowMaxZ = requiredCameraZ * 2;
        this.egoCamera.maxZ = this.camera.maxZ;
        if (this.model.formatVersion < 1100) {
            vf_tools_1.default.HdrToGamma = true;
            logger_1.default.debug("HDR to Gamma conversion enabled");
        }
        var s = Math.max(1, this.model.largestSize / 5);
        if (this.groundMirror) {
            this.groundMirror.scaling = new babylonjs_1.Vector3(s, s, s);
        }
        else {
            if (this.environment != null) {
                if (this.environment.ground != null) {
                    var scale = this.environment.ground.scaling.clone();
                    scale.scaleInPlace(const_1.default.GROUND_SCALE * s);
                    this.environment.ground.scaling = scale;
                }
            }
        }
        if (vf_config_manager_1.default.GetConfig().ignoreModelTrigger) {
            this.clearTriggers();
            logger_1.default.debug("WebPlayer configured to ignore model triggers");
        }
        else {
            this.setupTriggers(modelMeta);
        }
        this.loadObjects();
        this.applyMaterials().then(function () {
            _this.fixObjectPicking();
            _this.translateSceneOriginToNodePosition("surrogateRoot");
            _this.initCameraPosition();
            logger_1.default.debug("waiting to finish loading textures: " + _this.texturesToLoad);
            async_wait_until_1.waitUntil(function () { return _this.texturesToLoad < 1; }, { intervalBetweenAttempts: 200, timeout: async_wait_until_1.WAIT_FOREVER })
                .then(function () {
                _this.applyLightmaps().then(function () {
                    _this.applyEnvironment();
                    _this.finalizeMeshes();
                    _this.initCameraPosition();
                    _this.player.beforeCompleteSceneLoad(_this.name, _this.model.format, _this.model.formatVersion);
                    if (_this.player.config.initialTrigger != null) {
                        logger_1.default.debug("initial hotspot: " + _this.player.config.initialTrigger);
                        vf_ego_camera_1.default.SkipsNextEgoTransition = true;
                        _this.activateTrigger(_this.player.config.initialTrigger);
                    }
                    _this.executeWhenReady(function () {
                        _this.sceneIsReady = true;
                        if (!_this.willStillLoadEnvironment) {
                            _this.onSceneCompleteAndReady();
                        }
                    });
                });
            })
                .catch(function (error) {
                logger_1.default.error("failed to load some textures: " + error);
            });
        });
    };
    VFScene.prototype.onSceneCompleteAndReady = function () {
        this.finalizeMaterials();
        this.finalizeTextures();
        this.showTriggers();
        if (this.player.config.enableDimensioning) {
            this.addDimensionalMeasurement();
        }
        this.player.didCompleteSceneLoad(this.name, this.model.format, this.model.formatVersion);
        this.startAutorotate();
    };
    VFScene.prototype.onSceneFailedLoading = function (error) {
        this.player.didFailToLoad(error);
    };
    VFScene.prototype.startAutorotate = function (instant) {
        var _this = this;
        if (instant === void 0) { instant = false; }
        if (this.player.autorotationEnabled) {
            var spinupTime_1 = instant ? 0 : 6000;
            setTimeout(function () {
                _this.camera.useAutoRotationBehavior = true;
                _this.camera.autoRotationBehavior.idleRotationSpeed = 0.1;
                _this.camera.autoRotationBehavior.idleRotationSpinupTime = 3000;
                _this.camera.autoRotationBehavior.idleRotationSpinupTime = spinupTime_1;
                _this.camera.autoRotationBehavior.zoomStopsAnimation = true;
            }, spinupTime_1);
        }
    };
    VFScene.prototype.stopAutorotate = function () {
        this.camera.useAutoRotationBehavior = false;
    };
    VFScene.prototype.loadObjects = function () {
        var e_3, _a, e_4, _b;
        try {
            for (var _c = __values(this.getNodes()), _d = _c.next(); !_d.done; _d = _c.next()) {
                var node = _d.value;
                if (node instanceof babylonjs_1.TransformNode) {
                    this.loadObject(node);
                    try {
                        for (var _e = (e_4 = void 0, __values(node.getChildTransformNodes())), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var child = _f.value;
                            this.loadObject(child);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    VFScene.prototype.loadObject = function (node) {
        var objectPath = this.getPathForNode(node);
        var obj = this.model.getObjectAtPath(objectPath);
        var vfObject = new vf_object_1.default(objectPath, node, obj);
        this._obectsByPath[objectPath] = vfObject;
    };
    VFScene.prototype.fixObjectPicking = function () {
        var e_5, _a, e_6, _b, e_7, _c;
        try {
            for (var _d = __values(this.materials), _e = _d.next(); !_e.done; _e = _d.next()) {
                var material = _e.value;
                if (material instanceof babylonjs_1.PBRMaterial) {
                    if (material.transparencyMode > 1) {
                        try {
                            for (var _f = (e_6 = void 0, __values(Object.values(material.meshMap))), _g = _f.next(); !_g.done; _g = _f.next()) {
                                var mesh = _g.value;
                                if (this.model.getMeshes().includes(mesh)) {
                                    if (this.triggerMeshes.includes(mesh)) {
                                        continue;
                                    }
                                    material.needDepthPrePass = false;
                                    mesh.isPickable = false;
                                    if (mesh instanceof babylonjs_1.Mesh) {
                                        try {
                                            for (var _h = (e_7 = void 0, __values(mesh.instances)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                                var instance = _j.value;
                                                if (this.triggerMeshes.includes(instance)) {
                                                    continue;
                                                }
                                                instance.isPickable = false;
                                            }
                                        }
                                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                                        finally {
                                            try {
                                                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                            }
                                            finally { if (e_7) throw e_7.error; }
                                        }
                                    }
                                }
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                    }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    VFScene.prototype.applyEnvironment = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.model.hasProperties) {
                            return [2];
                        }
                        if (!(this.model.formatVersion < 1100)) return [3, 2];
                        return [4, this.applyReflection()];
                    case 1:
                        _a.sent();
                        return [2];
                    case 2: return [4, this.applyReflection()];
                    case 3:
                        _a.sent();
                        return [4, this.applyBackground()];
                    case 4:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    VFScene.prototype.applyReflection = function () {
        return __awaiter(this, void 0, void 0, function () {
            var environmentSettings, sides, textureName, path, urls, sides_1, sides_1_1, side, _a, _b, e_8_1, envTexture;
            var e_8, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        environmentSettings = this.model.properties["reflection"];
                        if (!environmentSettings || !(environmentSettings instanceof Object)) {
                            return [2];
                        }
                        if (environmentSettings instanceof Array && environmentSettings.length === 0) {
                            return [2];
                        }
                        this.willStillLoadEnvironment = true;
                        sides = [];
                        textureName = "";
                        if (this.model.formatVersion > 1000) {
                            sides.push(environmentSettings[0]);
                            sides.push(environmentSettings[2]);
                            sides.push(environmentSettings[4]);
                            sides.push(environmentSettings[1]);
                            sides.push(environmentSettings[3]);
                            sides.push(environmentSettings[5]);
                            textureName = environmentSettings[0].toLowerCase().replace("_positivex", "");
                        }
                        else {
                            sides.push(environmentSettings["PositiveX"]);
                            sides.push(environmentSettings["NegativeY"]);
                            sides.push(environmentSettings["PositiveZ"]);
                            sides.push(environmentSettings["NegativeX"]);
                            sides.push(environmentSettings["PositiveY"]);
                            sides.push(environmentSettings["NegativeZ"]);
                            environmentSettings["PositiveX"].toLowerCase().replace("_positivex", "");
                        }
                        path = "auraweb/tex_" + this.player.config.playerResolution;
                        urls = [];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        sides_1 = __values(sides), sides_1_1 = sides_1.next();
                        _d.label = 2;
                    case 2:
                        if (!!sides_1_1.done) return [3, 5];
                        side = sides_1_1.value;
                        _b = (_a = urls).push;
                        return [4, this.getTextureUrl(side, path)];
                    case 3:
                        _b.apply(_a, [_d.sent()]);
                        _d.label = 4;
                    case 4:
                        sides_1_1 = sides_1.next();
                        return [3, 2];
                    case 5: return [3, 8];
                    case 6:
                        e_8_1 = _d.sent();
                        e_8 = { error: e_8_1 };
                        return [3, 8];
                    case 7:
                        try {
                            if (sides_1_1 && !sides_1_1.done && (_c = sides_1.return)) _c.call(sides_1);
                        }
                        finally { if (e_8) throw e_8.error; }
                        return [7];
                    case 8:
                        envTexture = babylonjs_1.CubeTexture.CreateFromImages(urls, this, undefined);
                        envTexture.onLoadObservable.addOnce(function (eventData, eventState) {
                            envTexture.name = textureName;
                            envTexture.invertZ = false;
                            envTexture.rotationY = babylonjs_1.Tools.ToRadians(0);
                            envTexture.level = 1.5;
                            envTexture.coordinatesMode = babylonjs_1.RawTexture.CUBIC_MODE;
                            _this.environmentTexture = envTexture;
                            _this.render();
                            _this.willStillLoadEnvironment = false;
                            if (_this.sceneIsReady) {
                                _this.onSceneCompleteAndReady();
                            }
                        });
                        return [2];
                }
            });
        });
    };
    VFScene.prototype.normalizeModelTransform = function () {
        var root = this.getNodeByName("__root__");
        if (!root) {
            logger_1.default.error("scene does not contain the mandatory node named '__root__'");
            return;
        }
        var node0 = this.getNodeByName("node0");
        if (!node0) {
            logger_1.default.warn("scene does not contain the mandatory node named 'node0'");
            return;
        }
        root.scaling = vector_functions_1.makeAbs(root.scaling);
        root.rotate(new babylonjs_1.Vector3(0, 1, 0), -Math.PI, BABYLON.Space.WORLD);
        node0.scaling = vector_functions_1.makeAbs(node0.scaling);
        node0.rotate(new babylonjs_1.Vector3(0, 1, 0), -Math.PI, BABYLON.Space.LOCAL);
        node0.rotate(new babylonjs_1.Vector3(0, 0, 1), -Math.PI, BABYLON.Space.LOCAL);
    };
    VFScene.prototype.translateSceneOriginToNodePosition = function (nodeName) {
        if (nodeName === void 0) { nodeName = "surrogateRoot"; }
        var root = this.getNodeByName("__root__");
        var node0 = this.getNodeByName(nodeName);
        if (!root) {
            logger_1.default.error("scene does not contain the mandatory node named '__root__'");
            return;
        }
        if (!node0) {
            logger_1.default.warn("scene does not contain the node named " + nodeName + ". Skipping root centering");
            return;
        }
        node0.computeWorldMatrix(true);
        var translation = node0.getAbsolutePosition();
        node0.position.subtract(translation);
    };
    VFScene.prototype.applyBackground = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backgroundSettings, sides, textureName, path, urls, sides_2, sides_2_1, side, _a, _b, e_9_1, skyboxTexture, skybox;
            var e_9, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        backgroundSettings = this.model.properties["background"];
                        if (!backgroundSettings) {
                            return [2];
                        }
                        if (backgroundSettings instanceof Array && backgroundSettings.length === 0) {
                            return [2];
                        }
                        sides = [];
                        sides.push(backgroundSettings[0]);
                        sides.push(backgroundSettings[2]);
                        sides.push(backgroundSettings[4]);
                        sides.push(backgroundSettings[1]);
                        sides.push(backgroundSettings[3]);
                        sides.push(backgroundSettings[5]);
                        textureName = backgroundSettings[0].toLowerCase().replace("_positivex", "");
                        path = "auraweb/tex_" + this.player.config.playerResolution;
                        urls = [];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        sides_2 = __values(sides), sides_2_1 = sides_2.next();
                        _d.label = 2;
                    case 2:
                        if (!!sides_2_1.done) return [3, 5];
                        side = sides_2_1.value;
                        _b = (_a = urls).push;
                        return [4, this.getTextureUrl(side, path)];
                    case 3:
                        _b.apply(_a, [_d.sent()]);
                        _d.label = 4;
                    case 4:
                        sides_2_1 = sides_2.next();
                        return [3, 2];
                    case 5: return [3, 8];
                    case 6:
                        e_9_1 = _d.sent();
                        e_9 = { error: e_9_1 };
                        return [3, 8];
                    case 7:
                        try {
                            if (sides_2_1 && !sides_2_1.done && (_c = sides_2.return)) _c.call(sides_2);
                        }
                        finally { if (e_9) throw e_9.error; }
                        return [7];
                    case 8:
                        skyboxTexture = new babylonjs_1.CubeTexture("", this, sides, undefined, urls);
                        skyboxTexture.name = textureName;
                        skybox = this.createDefaultSkybox(skyboxTexture, false, 100, 0, false);
                        skybox.renderingGroupId = 0;
                        skyboxTexture.dispose();
                        skyboxTexture = null;
                        return [2];
                }
            });
        });
    };
    VFScene.prototype.applyMaterials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var materialPropertiesList, sceneMaterials, _loop_1, this_1, sceneMaterials_1, sceneMaterials_1_1, material;
            var e_10, _a;
            return __generator(this, function (_b) {
                if (!this.model.hasProperties) {
                    return [2];
                }
                materialPropertiesList = null;
                if (this.model.properties["materials"] instanceof Array) {
                    materialPropertiesList = this.model.properties["materials"];
                }
                else {
                    materialPropertiesList = Object.values(this.model.properties["materials"]);
                }
                sceneMaterials = this.materials;
                _loop_1 = function (material) {
                    var name_1 = material.name;
                    var materialProperties = materialPropertiesList.filter(function (mat) { return mat["name"] === name_1; });
                    var hash = materialProperties["hash"];
                    var vfMaterial = new vf_material_1.default(this_1, material, materialProperties);
                    this_1._materialsByName[name_1] = vfMaterial;
                    this_1._materialsByHash[hash] = vfMaterial;
                };
                this_1 = this;
                try {
                    for (sceneMaterials_1 = __values(sceneMaterials), sceneMaterials_1_1 = sceneMaterials_1.next(); !sceneMaterials_1_1.done; sceneMaterials_1_1 = sceneMaterials_1.next()) {
                        material = sceneMaterials_1_1.value;
                        _loop_1(material);
                    }
                }
                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                finally {
                    try {
                        if (sceneMaterials_1_1 && !sceneMaterials_1_1.done && (_a = sceneMaterials_1.return)) _a.call(sceneMaterials_1);
                    }
                    finally { if (e_10) throw e_10.error; }
                }
                if (this.model.formatVersion < 1100) {
                    this.applyMaterialsV1000();
                }
                else {
                    this.applyMaterialsV1100();
                }
                return [2];
            });
        });
    };
    VFScene.prototype.applyMaterialsV1100 = function () {
        var e_11, _a, e_12, _b;
        try {
            for (var _c = __values(this.materials), _d = _c.next(); !_d.done; _d = _c.next()) {
                var material = _d.value;
                var modelMaterial = this.model.getMaterialForName(material.name);
                if (!modelMaterial) {
                    continue;
                }
                if (material instanceof babylonjs_1.PBRMaterial) {
                    var pbrMaterial = material;
                    this.applyPBRMaterialV1100(modelMaterial, pbrMaterial);
                }
                else if (material instanceof babylonjs_1.StandardMaterial) {
                    var standardMaterial = material;
                    this.applyStandardMaterialV1100(modelMaterial, standardMaterial);
                }
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_11) throw e_11.error; }
        }
        var allMeshes = this.getAllMeshes();
        try {
            for (var allMeshes_1 = __values(allMeshes), allMeshes_1_1 = allMeshes_1.next(); !allMeshes_1_1.done; allMeshes_1_1 = allMeshes_1.next()) {
                var mesh = allMeshes_1_1.value;
                if (!mesh.parent) {
                    continue;
                }
                var path = this.getPathForNode(mesh);
                if (path.includes("_node")) {
                    logger_1.default.error("applyMaterialsV1100: invalid path " + path);
                }
                var obj = this.model.getObjectAtPath(path);
                if (!obj) {
                    logger_1.default.debug("no object in model for node with path", path);
                }
                if (obj) {
                    var materialHash = obj.material;
                    var material = this.model.getMaterialForHash(materialHash);
                    var anMaterial = this.getOrCreateMaterialWithName(material.name);
                    if (anMaterial != null) {
                        try {
                            if (mesh.material == null || mesh.material.name !== anMaterial.name) {
                                var oldMaterialName = mesh.material.name;
                                if (mesh.isAnInstance) {
                                    this.createObjectForInstance(mesh, anMaterial);
                                }
                                else {
                                    mesh.material = anMaterial;
                                }
                            }
                        }
                        catch (e) {
                            logger_1.default.warn(e);
                        }
                    }
                }
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (allMeshes_1_1 && !allMeshes_1_1.done && (_b = allMeshes_1.return)) _b.call(allMeshes_1);
            }
            finally { if (e_12) throw e_12.error; }
        }
    };
    VFScene.prototype.applyStandardMaterialV1100 = function (materialInfo, material) {
        var e_13, _a;
        material["skipLightmap"] = false;
        if (materialInfo.shader_name.includes("Unlit")) {
            material["skipLightmap"] = true;
        }
        material.ambientColor = babylonjs_1.Color3.White();
        var properties = materialInfo.values;
        try {
            for (var _b = __values(Object.keys(properties)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var property = properties[key];
                if (key === "main_tex") {
                    if (material.diffuseTexture) {
                        var albedoTexture = material.diffuseTexture;
                        albedoTexture.uScale = property.scale.x;
                        albedoTexture.vScale = -property.scale.y;
                        albedoTexture.uOffset = property.offset.x;
                        albedoTexture.vOffset = -property.offset.y;
                        albedoTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                    }
                }
                else if (key === "bump_map") {
                    if (material.bumpTexture) {
                        var bumpTexture = material.bumpTexture;
                        bumpTexture.uScale = property.scale.x;
                        bumpTexture.vScale = -property.scale.y;
                        bumpTexture.uOffset = property.offset.x;
                        bumpTexture.vOffset = -property.offset.y;
                        bumpTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                    }
                }
                else if (key === "emission_map") {
                    if (property.texture !== 0 && material.diffuseTexture) {
                        material.diffuseColor = new babylonjs_1.Color3(1, 1, 1);
                        material.emissiveTexture = material.diffuseTexture;
                    }
                }
                else if (key === "emission_color") {
                    material.emissiveColor = new babylonjs_1.Color3(property.r, property.g, property.b);
                    if (material.diffuseTexture) {
                        material.emissiveTexture = material.diffuseTexture;
                    }
                }
                else if (key === "color") {
                    material.diffuseColor = new babylonjs_1.Color3(property.r, property.g, property.b);
                }
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_13) throw e_13.error; }
        }
    };
    VFScene.prototype.applyPBRMaterialV1100 = function (materialInfo, material) {
        return __awaiter(this, void 0, void 0, function () {
            var isStandardShader, willLoadTexture, properties, isLightmap, _loop_2, this_2, _a, _b, key, metallic, glossiness, meshes_2, meshes_1, meshes_1_1, mesh1;
            var e_14, _c, e_15, _d;
            var _this = this;
            return __generator(this, function (_e) {
                material.roughness = 1;
                material.metallic = 0;
                material.emissiveIntensity = 1;
                material.specularIntensity = 1;
                material.directIntensity = 1;
                material.ambientColor = babylonjs_1.Color3.Gray();
                material.reflectionColor = babylonjs_1.Color3.White();
                material.disableLighting = false;
                isStandardShader = materialInfo.shader_name.includes("Standard (Specular setup)") || materialInfo.shader_name === "Standard";
                if (materialInfo.shader_name.includes("Standard (Specular setup)")) {
                    material.roughness = 1;
                }
                else if (materialInfo.shader_name.includes("Standard")) {
                    material.roughness = 0;
                }
                material["shader"] = materialInfo.shader_name;
                material["keywords"] = materialInfo.keywords;
                if (materialInfo.render_type === "Transparent") {
                    material.transparencyMode = 2;
                    material.alphaMode = BABYLON.Constants.ALPHA_PREMULTIPLIED;
                    material.useAlphaFromAlbedoTexture = true;
                }
                else if (materialInfo.render_type === "TransparentCutout") {
                    material.transparencyMode = 1;
                    material.alphaMode = BABYLON.Constants.ALPHA_PREMULTIPLIED;
                    material.useAlphaFromAlbedoTexture = true;
                }
                willLoadTexture = false;
                properties = materialInfo.values;
                properties["glossiness"] = properties["glossiness"] || 0;
                properties["metallic"] = properties["metallic"] || 0;
                properties["bump_scale"] = properties["bump_scale"] || 1;
                properties["occlusion_strength"] = properties["occlusion_strength"] || 1;
                properties["specular_highlights"] = properties["specular_highlights"] || 1;
                properties["gloss_map_scale"] = properties["gloss_map_scale"] || 1;
                isLightmap = false;
                material["skipLightmap"] = false;
                material["willLoadTexture"] = 0;
                _loop_2 = function (key) {
                    var property = properties[key];
                    if (key === "cutoff") {
                        if (materialInfo.render_type === "TransparentCutout") {
                            material.alpha = property;
                        }
                    }
                    else if (key === "main_tex") {
                        if (!this_2.isValidTexture(material.albedoTexture)) {
                            if (property.texture !== 0) {
                                var name_2 = this_2.model.findTextureNameForHash(property.texture);
                                if (!name_2) {
                                    var meshs = Object.values(material.meshMap);
                                }
                                if (!name_2) {
                                    throw new Error("model has no properties");
                                }
                                material["willLoadTexture"] += 1;
                                this_2.findOrLoadTexture(name_2, property, "(Base Color)", true, false, function (texture) {
                                    if (material.isFrozen) {
                                        logger_1.default.error(material.name + ": tried to set texture on frozen material, texture " + texture.name);
                                    }
                                    texture.uScale = property.scale.x;
                                    texture.vScale = -property.scale.y;
                                    texture.uOffset = property.offset.x;
                                    texture.vOffset = -property.offset.y;
                                    texture.uAng = babylonjs_1.Tools.ToRadians(180);
                                    material.albedoTexture = texture;
                                    _this.onTextureLoaded(material);
                                });
                                willLoadTexture = true;
                            }
                        }
                        else {
                            var texture = material.albedoTexture;
                            texture.uScale = property.scale.x;
                            texture.vScale = -property.scale.y;
                            texture.uOffset = property.offset.x;
                            texture.vOffset = -property.offset.y;
                            texture.uAng = babylonjs_1.Tools.ToRadians(180);
                        }
                    }
                    else if (key === "bump_map") {
                        if (!this_2.isValidTexture(material.bumpTexture)) {
                            if (property.texture !== 0) {
                                var name_3 = this_2.model.findTextureNameForHash(property.texture);
                                material["willLoadTexture"] += 1;
                                this_2.findOrLoadTexture(name_3, property, "(Bump Map)", true, false, function (texture) {
                                    material.bumpTexture = texture;
                                    texture.uScale = property.scale.x;
                                    texture.vScale = -property.scale.y;
                                    texture.uOffset = property.offset.x;
                                    texture.vOffset = -property.offset.y;
                                    texture.level = 2.0;
                                    texture.uAng = babylonjs_1.Tools.ToRadians(180);
                                    if (material.isFrozen) {
                                        logger_1.default.error(material.name + ": tried to set texture on frozen material, texture " + texture.name);
                                    }
                                    _this.onTextureLoaded(material);
                                });
                                willLoadTexture = true;
                            }
                        }
                        else {
                            var texture = material.bumpTexture;
                            texture.uScale = property.scale.x;
                            texture.vScale = -property.scale.y;
                            texture.uOffset = property.offset.x;
                            texture.vOffset = -property.offset.y;
                            texture.level = 2.0;
                            texture.uAng = babylonjs_1.Tools.ToRadians(180);
                        }
                    }
                    else if (key === "emission_color") {
                        if (!vf_tools_1.default.isEmptyColor0(property)) {
                            material["needsEmissiveTexture"] = true;
                            material.emissiveColor = vf_tools_1.default.GammaColor(property);
                            if (!material.emissiveTexture) {
                                if (material.albedoTexture) {
                                    material.emissiveTexture = material.albedoTexture;
                                    if (material.isFrozen) {
                                        logger_1.default.error(material.name + ": tried replace emissiveTexture on frozen material");
                                    }
                                    material["needsEmissiveTexture"] = true;
                                }
                            }
                        }
                    }
                    else if (key === "emission_map") {
                        if (property.texture !== 0) {
                            var name_4 = this_2.model.findTextureNameForHash(property.texture);
                            material["willLoadTexture"] += 1;
                            this_2.findOrLoadTexture(name_4, property, "(Emissive)", true, false, function (texture) {
                                material.emissiveTexture = texture;
                                if (material.isFrozen) {
                                    logger_1.default.error(material.name + ": tried to set texture on frozen material, texture " + texture.name);
                                }
                                _this.onTextureLoaded(material);
                            });
                        }
                    }
                    else if (key === "color") {
                        if (materialInfo.shader_name.includes("Unlit")) {
                            material.albedoColor = vf_tools_1.default.GammaColor(property);
                            material.emissiveColor = vf_tools_1.default.GammaColor(property);
                            material["skipLightmap"] = true;
                        }
                        else {
                            material.albedoColor = vf_tools_1.default.GammaColor(property);
                        }
                        if (property.a < 1.0) {
                            material.alpha = property.a;
                        }
                    }
                    else if (key === "spec_color") {
                        material.reflectivityColor = vf_tools_1.default.GammaColor(property);
                    }
                    else if (key === "glossiness" || key === "gloss" || key === "metallic") {
                        material[key] = property;
                    }
                    else if (key === "roughness") {
                        if (isStandardShader) {
                            material.roughness = property;
                        }
                    }
                };
                this_2 = this;
                try {
                    for (_a = __values(Object.keys(properties)), _b = _a.next(); !_b.done; _b = _a.next()) {
                        key = _b.value;
                        _loop_2(key);
                    }
                }
                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_14) throw e_14.error; }
                }
                if (isStandardShader) {
                    metallic = material["metallic"];
                    glossiness = material["glossiness"] || 0.0;
                    material.specularIntensity = (0.5 - Math.abs(metallic - 0.5)) * 2.0;
                    if (materialInfo.shader_name.includes("Standard (Specular setup)")) {
                        material.metallic = (1.0 - glossiness) * 0.25;
                        material.roughness = material.specularIntensity;
                    }
                    else {
                        material.metallic = metallic + (1.0 - glossiness) * 0.25;
                        material.roughness = (1.0 - glossiness) * material.metallic;
                        material.indexOfRefraction = 1.0 + glossiness;
                        material.metallicF0Factor = glossiness;
                        material.environmentIntensity = Math.min(1.0, 0.5 + (glossiness + metallic) * 0.5);
                    }
                }
                if (materialInfo.shader_name.includes("Unlit")) {
                    material["skipLightmap"] = true;
                    material.disableLighting = true;
                    material.emissiveIntensity = 1;
                    material.emissiveColor = new babylonjs_1.Color3(3.0 / 255, 3.0 / 255, 3.0 / 255);
                    if (materialInfo.shader_name === "Unlit/Transparent" ||
                        materialInfo.shader_name === "Unlit/Texture" ||
                        materialInfo.shader_name === "Unlit/Color") {
                        material.emissiveColor = material.albedoColor;
                        material.emissiveTexture = material.albedoTexture;
                        material["needsEmissiveTexture"] = true;
                        material.environmentIntensity = 0;
                    }
                }
                else if (materialInfo.shader_name.includes("Lightmap as Diffuse (with UV1)")) {
                    material["skipLightmap"] = true;
                    material.disableLighting = true;
                    material.unlit = true;
                    material.emissiveIntensity = 0;
                    material.specularIntensity = 0;
                    material.environmentIntensity = 0;
                    material.useAlphaFromAlbedoTexture = true;
                    material.ambientColor = babylonjs_1.Color3.White();
                    material.transparencyMode = 2;
                    material.alphaMode = BABYLON.Constants.ALPHA_MULTIPLY;
                    isLightmap = true;
                }
                else if (materialInfo.shader_name.includes("Lightmap-only")) {
                    material["lightmapIsTexture"] = true;
                    material.disableLighting = true;
                    material.alpha = properties["alpha"];
                    material.unlit = false;
                    material.emissiveIntensity = 0;
                    material.specularIntensity = 0;
                    material.environmentIntensity = 0;
                    material.useAlphaFromAlbedoTexture = true;
                    material.ambientColor = babylonjs_1.Color3.White();
                    material.transparencyMode = 2;
                    isLightmap = true;
                }
                if (isLightmap) {
                    if (willLoadTexture) {
                        meshes_2 = material.getBindedMeshes();
                        try {
                            for (meshes_1 = __values(meshes_2), meshes_1_1 = meshes_1.next(); !meshes_1_1.done; meshes_1_1 = meshes_1.next()) {
                                mesh1 = meshes_1_1.value;
                                mesh1.setEnabled(false);
                            }
                        }
                        catch (e_15_1) { e_15 = { error: e_15_1 }; }
                        finally {
                            try {
                                if (meshes_1_1 && !meshes_1_1.done && (_d = meshes_1.return)) _d.call(meshes_1);
                            }
                            finally { if (e_15) throw e_15.error; }
                        }
                        setTimeout(function () {
                            var e_16, _a;
                            try {
                                for (var meshes_3 = __values(meshes_2), meshes_3_1 = meshes_3.next(); !meshes_3_1.done; meshes_3_1 = meshes_3.next()) {
                                    var mesh1 = meshes_3_1.value;
                                    mesh1.setEnabled(true);
                                }
                            }
                            catch (e_16_1) { e_16 = { error: e_16_1 }; }
                            finally {
                                try {
                                    if (meshes_3_1 && !meshes_3_1.done && (_a = meshes_3.return)) _a.call(meshes_3);
                                }
                                finally { if (e_16) throw e_16.error; }
                            }
                        }, 500);
                    }
                }
                return [2];
            });
        });
    };
    VFScene.prototype.onTextureLoaded = function (material) {
        if (material["needsEmissiveTexture"] === true) {
            material.emissiveTexture = material.albedoTexture;
        }
        if (material["shader"].includes("Lightmap as Diffuse (with UV1)")) {
            var texture = material.albedoTexture;
            texture.coordinatesIndex = 1;
            if (material["keywords"]) {
                if (material["keywords"].includes("_UVSEC_UV1")) {
                    texture.coordinatesIndex = 0;
                }
            }
        }
        if (material.name.startsWith("__floor_ao")) {
            material.albedoTexture.hasAlpha = true;
        }
        material["willLoadTexture"] -= 1;
    };
    VFScene.prototype.isValidTexture = function (texture) {
        if (!texture) {
            return false;
        }
        if (!texture.getSize().height) {
            logger_1.default.error(texture.name + " is invalid");
            return false;
        }
        if (!texture.getSize().width) {
            logger_1.default.error(texture.name + " is invalid");
            return false;
        }
        if (!texture.getInternalTexture()) {
            logger_1.default.error(texture.name + " is invalid");
            return false;
        }
        return true;
    };
    VFScene.prototype.applyMaterialsV1000 = function () {
        var e_17, _a, e_18, _b, e_19, _c;
        try {
            for (var _d = __values(Object.keys(this.model.properties["materials"])), _e = _d.next(); !_e.done; _e = _d.next()) {
                var materialId = _e.value;
                var materialInfo = this.model.properties["materials"][materialId];
                try {
                    for (var _f = (e_18 = void 0, __values(this.materials)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var material = _g.value;
                        if (material.name === materialInfo.name) {
                            if (material instanceof babylonjs_1.PBRMaterial) {
                                var pbrMaterial = material;
                                this.applyPBRMaterialV1000(materialInfo, pbrMaterial);
                                if (materialInfo.shader_name.includes("Lightmap")) {
                                    pbrMaterial.transparencyMode = 2;
                                    pbrMaterial.alphaMode = BABYLON.Constants.ALPHA_MULTIPLY;
                                    pbrMaterial.zOffset = -3.5;
                                }
                            }
                            else if (material instanceof babylonjs_1.StandardMaterial) {
                                var standardMaterial = material;
                                this.applyStandardMaterialV1000(materialInfo, standardMaterial);
                            }
                        }
                    }
                }
                catch (e_18_1) { e_18 = { error: e_18_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_18) throw e_18.error; }
                }
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_17) throw e_17.error; }
        }
        if (this.model.properties["objects"]) {
            var allMeshes = this.getAllMeshes();
            try {
                for (var allMeshes_2 = __values(allMeshes), allMeshes_2_1 = allMeshes_2.next(); !allMeshes_2_1.done; allMeshes_2_1 = allMeshes_2.next()) {
                    var mesh = allMeshes_2_1.value;
                    if (mesh.parent != null) {
                        var path = this.getPathForNode(mesh).split("_node")[0];
                        var materialName = this.model.properties["objects"][path];
                        if (materialName) {
                            var anMaterial = this.getOrCreateMaterialWithName(materialName);
                            if (anMaterial != null) {
                                try {
                                    if (mesh.material == null || mesh.material.name !== anMaterial.name) {
                                        var oldMaterialName = mesh.material.name;
                                        if (mesh.isAnInstance) {
                                            this.createObjectForInstance(mesh, anMaterial);
                                        }
                                        else {
                                            mesh.material = anMaterial;
                                        }
                                    }
                                }
                                catch (e) {
                                    logger_1.default.warn(e);
                                }
                            }
                        }
                    }
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (allMeshes_2_1 && !allMeshes_2_1.done && (_c = allMeshes_2.return)) _c.call(allMeshes_2);
                }
                finally { if (e_19) throw e_19.error; }
            }
        }
    };
    VFScene.prototype.applyStandardMaterialV1000 = function (materialInfo, material) {
        var e_20, _a;
        if (this.model.formatVersion < 1100) {
            this.applyStandardMaterialV1000(materialInfo, material);
            return;
        }
        try {
            for (var _b = __values(materialInfo.material_properties), _c = _b.next(); !_c.done; _c = _b.next()) {
                var property = _c.value;
                if (property.name === "_MainTex") {
                    if (material.diffuseTexture) {
                        var albedoTexture = material.diffuseTexture;
                        albedoTexture.uScale = property.scale.x;
                        albedoTexture.vScale = -property.scale.y;
                        albedoTexture.uOffset = property.offset.x;
                        albedoTexture.vOffset = -property.offset.y;
                        albedoTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                    }
                }
                else if (property.name === "_BumpMap") {
                    if (material.bumpTexture) {
                        var bumpTexture = material.bumpTexture;
                        bumpTexture.uScale = property.scale.x;
                        bumpTexture.vScale = -property.scale.y;
                        bumpTexture.uOffset = property.offset.x;
                        bumpTexture.vOffset = -property.offset.y;
                        bumpTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                    }
                }
                else if (property.name === "_EmissionMap") {
                    if (property.texture !== 0 && material.diffuseTexture) {
                        material.diffuseColor = new babylonjs_1.Color3(1, 1, 1);
                        material.emissiveTexture = material.diffuseTexture;
                        material["needsEmissiveTexture"] = true;
                    }
                }
                else if (property.name === "_EmissionColor") {
                    material.emissiveColor = new babylonjs_1.Color3(property.color.r, property.color.g, property.color.b);
                }
                else if (property.name === "_Color") {
                    material.diffuseColor = new babylonjs_1.Color3(property.color.r, property.color.g, property.color.b);
                }
            }
        }
        catch (e_20_1) { e_20 = { error: e_20_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_20) throw e_20.error; }
        }
    };
    VFScene.prototype.applyPBRMaterialV1000 = function (materialInfo, material) {
        return __awaiter(this, void 0, void 0, function () {
            var isStandardShader, _a, _b, property, name_5, albedoTexture, bumpTexture, bumpTexture, name_6;
            var e_21, _c;
            return __generator(this, function (_d) {
                material.roughness = 1;
                material.metallic = 0;
                material.emissiveIntensity = 0;
                material.disableLighting = false;
                isStandardShader = materialInfo.shader_name.includes("Standard (Specular setup)") || materialInfo.shader_name === "Standard";
                if (materialInfo.shader_name.includes("Standard (Specular setup)")) {
                    material.roughness = 1;
                }
                else if (materialInfo.shader_name.includes("Standard")) {
                    material.roughness = 0;
                }
                if (materialInfo.render_type === "Transparent") {
                    material.transparencyMode = 2;
                    material.alphaMode = BABYLON.Constants.ALPHA_PREMULTIPLIED;
                    material.useAlphaFromAlbedoTexture = true;
                }
                else if (materialInfo.render_type === "TransparentCutout") {
                    material.transparencyMode = 1;
                    material.alphaMode = BABYLON.Constants.ALPHA_PREMULTIPLIED;
                    material.useAlphaFromAlbedoTexture = true;
                }
                try {
                    for (_a = __values(materialInfo.material_properties), _b = _a.next(); !_b.done; _b = _a.next()) {
                        property = _b.value;
                        if (property.name === "_Cutoff") {
                            if (materialInfo.render_type === "TransparentCutout") {
                                material.alpha = property.value;
                            }
                        }
                        else if (property.name === "_MainTex") {
                            if (material.albedoTexture == null) {
                                if (property.texture !== 0) {
                                    name_5 = this.model.findTextureNameForHash(property.texture);
                                    if (!name_5) {
                                        throw new Error("model has no properties");
                                    }
                                    else {
                                        this.findOrLoadTexture(name_5, property, "(Base Color)", true, false, function (texture) {
                                            material.albedoTexture = texture;
                                        });
                                    }
                                }
                            }
                            if (material.albedoTexture != null) {
                                albedoTexture = material.albedoTexture;
                                albedoTexture.uScale = property.scale.x;
                                albedoTexture.vScale = -property.scale.y;
                                albedoTexture.uOffset = property.offset.x;
                                albedoTexture.vOffset = -property.offset.y;
                                if (!material["skipLightmap"]) {
                                    albedoTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                                }
                                material.albedoTexture = albedoTexture;
                            }
                            if (materialInfo.shader_name.includes("Standard")) {
                                if (material.bumpTexture != null) {
                                    bumpTexture = material.bumpTexture;
                                    bumpTexture.uScale = property.scale.x;
                                    bumpTexture.vScale = -property.scale.y;
                                    bumpTexture.uOffset = property.offset.x;
                                    bumpTexture.vOffset = -property.offset.y;
                                    bumpTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                                    material.bumpTexture = bumpTexture;
                                }
                            }
                        }
                        else if (property.name === "_BumpMap") {
                            if (!materialInfo.shader_name.includes("Standard")) {
                                if (material.bumpTexture != null) {
                                    bumpTexture = material.bumpTexture;
                                    bumpTexture.uScale = property.scale.x;
                                    bumpTexture.vScale = -property.scale.y;
                                    bumpTexture.uOffset = property.offset.x;
                                    bumpTexture.vOffset = -property.offset.y;
                                    bumpTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                                    material.bumpTexture = bumpTexture;
                                }
                            }
                        }
                        else if (property.name === "_EmissionMap") {
                            if (property.texture !== 0) {
                                material.emissiveIntensity = 1;
                                name_6 = this.model.findTextureNameForHash(property.texture);
                                this.findOrLoadTexture(name_6, property, "(Emissive)", true, false, function (texture) {
                                    material.emissiveTexture = texture;
                                });
                            }
                        }
                        else if (property.name === "_EmissionColor") {
                            material.emissiveColor = vf_tools_1.default.GammaColor(property.color);
                            material.emissiveIntensity = 1;
                        }
                        else if (property.name === "_Color") {
                            if (materialInfo.shader_name.includes("Unlit")) {
                                material.emissiveColor = vf_tools_1.default.GammaColor(property.color);
                            }
                            else {
                                material.albedoColor = vf_tools_1.default.GammaColor(property.color);
                            }
                            if (property.color.a < 1.0) {
                                material.alpha = property.color.a;
                            }
                        }
                        else if (property.name === "_SpecColor") {
                            material.reflectivityColor = vf_tools_1.default.GammaColor(property.color);
                        }
                        else if (property.name === "_Glossiness" || property.name === "_Gloss") {
                            if (isStandardShader) {
                                if (materialInfo.shader_name.includes("Standard (Specular setup)")) {
                                    material.roughness = 1.0 - vf_tools_1.default.gammaToLinearSpace(property.value);
                                }
                                else {
                                    material.roughness = vf_tools_1.default.gammaToLinearSpace(property.value);
                                }
                                material.specularIntensity = 1.0 - material.roughness;
                            }
                        }
                        else if (property.name === "_Roughness") {
                            if (isStandardShader) {
                                material.roughness = property.value;
                            }
                        }
                        else if (property.name === "_Metallic") {
                            if (isStandardShader) {
                                material.metallic = vf_tools_1.default.linearToGammaSpace(property.value);
                                material.specularIntensity = property.value;
                                material.directIntensity = 1 - material.metallic;
                            }
                        }
                        if (materialInfo.shader_name.includes("Unlit")) {
                            material["skipLightmap"] = true;
                            material.disableLighting = true;
                            material.emissiveIntensity = 1;
                            material.emissiveColor = new babylonjs_1.Color3(3.0 / 255, 3.0 / 255, 3.0 / 255);
                            if (materialInfo.shader_name === "Unlit/Transparent" || materialInfo.shader_name === "Unlit/Texture") {
                                material.emissiveColor = babylonjs_1.Color3.White();
                                material.emissiveTexture = material.albedoTexture;
                                material["needsEmissiveTexture"] = true;
                                material.environmentIntensity = 0;
                            }
                        }
                    }
                }
                catch (e_21_1) { e_21 = { error: e_21_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_21) throw e_21.error; }
                }
                return [2];
            });
        });
    };
    VFScene.prototype.getMaterialForName = function (name) {
        var e_22, _a;
        if (this._materialsByName[name]) {
            return this._materialsByName[name];
        }
        var materials = this.model.properties["materials"];
        try {
            try {
                for (var materials_1 = __values(materials), materials_1_1 = materials_1.next(); !materials_1_1.done; materials_1_1 = materials_1.next()) {
                    var mat = materials_1_1.value;
                    if (name === mat["name"]) {
                        var hash = mat["hash"];
                        var babylonMaterials = this.materials.filter(function (mat) { return mat.name === name; });
                        if (babylonMaterials.length > 0) {
                            if (babylonMaterials.length > 1) {
                                logger_1.default.warn("multiple materials for name " + name);
                            }
                            var vfMaterial = new vf_material_1.default(this, babylonMaterials[0], mat);
                            this._materialsByName[name] = vfMaterial;
                            this._materialsByHash[hash] = vfMaterial;
                            return vfMaterial;
                        }
                    }
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (materials_1_1 && !materials_1_1.done && (_a = materials_1.return)) _a.call(materials_1);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        catch (e) {
            return null;
        }
        return null;
    };
    VFScene.prototype.getMaterialForHash = function (hash) {
        var e_23, _a;
        if (this._materialsByHash[hash]) {
            return this._materialsByHash[hash];
        }
        var materials = this.model.properties["materials"];
        var _loop_3 = function (mat) {
            if (hash === mat["hash"]) {
                var name_7 = mat["name"];
                var babylonMaterials = this_3.materials.filter(function (mat) { return mat.name === name_7; });
                if (babylonMaterials.length > 0) {
                    if (babylonMaterials.length > 1) {
                        logger_1.default.warn("multiple materials for name " + name_7);
                    }
                    var vfMaterial = new vf_material_1.default(this_3, babylonMaterials[0], mat);
                    this_3._materialsByName[name_7] = vfMaterial;
                    this_3._materialsByHash[hash] = vfMaterial;
                    return { value: vfMaterial };
                }
                logger_1.default.warn("no babylon material for hash " + hash + " " + name_7);
            }
        };
        var this_3 = this;
        try {
            for (var materials_2 = __values(materials), materials_2_1 = materials_2.next(); !materials_2_1.done; materials_2_1 = materials_2.next()) {
                var mat = materials_2_1.value;
                var state_1 = _loop_3(mat);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        catch (e_23_1) { e_23 = { error: e_23_1 }; }
        finally {
            try {
                if (materials_2_1 && !materials_2_1.done && (_a = materials_2.return)) _a.call(materials_2);
            }
            finally { if (e_23) throw e_23.error; }
        }
        logger_1.default.warn("no material for hash " + hash);
        return null;
    };
    VFScene.prototype.getMaterialNameForObjectPath = function (path) {
        if (!this.model.hasProperties) {
            return null;
        }
        if (this.model.formatVersion < 1100) {
            return this.model.properties["objects"][path];
        }
        var obj = this.model.getObjectAtPath(path);
        if (obj) {
            var matHash = obj.material;
            var material = this.model.getMaterialForHash(matHash);
            if (!material) {
                return null;
            }
            return material.name;
        }
        return null;
    };
    VFScene.prototype.getMaterialForObject = function (object) {
        var path = this.getPathForNode(object);
        return this.getMaterialForObjectPath(path);
    };
    VFScene.prototype.getMaterialForObjectPath = function (path) {
        var materialName = this.getMaterialNameForObjectPath(path);
        if (materialName) {
            var anMaterial = this.getOrCreateMaterialWithName(materialName);
            if (anMaterial != null) {
                return anMaterial;
            }
        }
        return null;
    };
    VFScene.prototype.getMaterialWithName = function (name) {
        return this.materials.find(function (value) { return value.name === name; });
    };
    VFScene.prototype.getOrCreateMaterialWithName = function (name) {
        var anMaterial = this.getMaterialWithName(name);
        if (anMaterial == null) {
            var materialInfo = this.getMaterialInfoWithName(name);
            var pbrMaterial = new babylonjs_1.PBRMaterial(materialInfo.name, this);
            if (this.model.formatVersion < 1100) {
                this.applyPBRMaterialV1000(materialInfo, pbrMaterial);
            }
            else {
                this.applyPBRMaterialV1100(materialInfo, pbrMaterial);
            }
            anMaterial = pbrMaterial;
        }
        return anMaterial;
    };
    VFScene.prototype.getMaterialInfoWithName = function (name) {
        var _this = this;
        var key = Object.keys(this.model.properties["materials"]).find(function (k) { return _this.model.properties["materials"][k].name === name; });
        if (!key) {
            return null;
        }
        return this.model.properties["materials"][key];
    };
    VFScene.prototype.finalizeMaterials = function () {
        var e_24, _a;
        if (this.materialsAreFrozen) {
            return;
        }
        if (vf_config_manager_1.default.enableDebug) {
            logger_1.default.warn("DEBUG MODE: not finalizing materials");
            return;
        }
        this.materialsAreFrozen = true;
        try {
            for (var _b = __values(this.materials), _c = _b.next(); !_c.done; _c = _b.next()) {
                var material = _c.value;
                material.freeze();
            }
        }
        catch (e_24_1) { e_24 = { error: e_24_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_24) throw e_24.error; }
        }
    };
    Object.defineProperty(VFScene.prototype, "useLightmaps", {
        get: function () {
            if (this.player.config.skipLightmaps) {
                logger_1.default.warn("skip lightmaps is enabled (lm=0)");
                return false;
            }
            return this.model.hasLightmaps && !this.player.config.skipLightmaps;
        },
        enumerable: true,
        configurable: true
    });
    VFScene.prototype.applyLightmaps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var root, root, _a, _b, lightmappedObject, e_25_1;
            var e_25, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(this.model.formatVersion >= 1100)) return [3, 2];
                        if (!this.useLightmaps) {
                            this.skylight.intensity = 1;
                            this.skylight.diffuse = this.skylight.diffuse.scale(0.5);
                            this.skylight.groundColor = babylonjs_1.Color3.Black();
                            return [2];
                        }
                        this.skylight.intensity *= 0.6;
                        root = this.model.getRoot();
                        return [4, this.applyLightmapsToNodeV1100(root)];
                    case 1:
                        _d.sent();
                        return [3, 10];
                    case 2:
                        if (!this.useLightmaps) {
                            return [2];
                        }
                        this.skylight.intensity *= 0.6;
                        this._lightmappedObjects = new Array();
                        root = this.model.getRoot();
                        this.applyLightmapsToNodeV1000(root);
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 8, 9, 10]);
                        _a = __values(this._lightmappedObjects), _b = _a.next();
                        _d.label = 4;
                    case 4:
                        if (!!_b.done) return [3, 7];
                        lightmappedObject = _b.value;
                        return [4, this.applyLightmapToMeshV1000(lightmappedObject[0], lightmappedObject[1], lightmappedObject[2])];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [3, 4];
                    case 7: return [3, 10];
                    case 8:
                        e_25_1 = _d.sent();
                        e_25 = { error: e_25_1 };
                        return [3, 10];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_25) throw e_25.error; }
                        return [7];
                    case 10: return [2];
                }
            });
        });
    };
    VFScene.prototype.applyLightmapsToNodeV1000 = function (rootNode) {
        var e_26, _a, e_27, _b, e_28, _c, e_29, _d;
        var rootPath = this.getPathForNode(rootNode);
        var nodes = rootNode.getChildren();
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var node = nodes_1_1.value;
                node.name = node.name.split("_node")[0];
                var path = rootPath + "/" + node.name;
                var fixedPath = rootPath + "/" + node.name.replace(node.parent.name + ".", "");
                if (node instanceof babylonjs_1.AbstractMesh) {
                    if (node.material) {
                        if (node.material["skipLightmap"] === true) {
                            continue;
                        }
                    }
                    try {
                        for (var _e = (e_27 = void 0, __values(this.model.properties["lightmaps"])), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var lightmapInfo = _f.value;
                            try {
                                for (var _g = (e_28 = void 0, __values(lightmapInfo.objects)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    var object = _h.value;
                                    if ((path === object.path || fixedPath === object.path) && !path.includes("_nonPBR")) {
                                        var resolvedNode = node;
                                        if (node.isAnInstance) {
                                            resolvedNode = this.createObjectForInstance(node, node.material);
                                        }
                                        this._lightmappedObjects.push([resolvedNode, lightmapInfo.name, object]);
                                    }
                                }
                            }
                            catch (e_28_1) { e_28 = { error: e_28_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                                }
                                finally { if (e_28) throw e_28.error; }
                            }
                        }
                    }
                    catch (e_27_1) { e_27 = { error: e_27_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_27) throw e_27.error; }
                    }
                }
            }
        }
        catch (e_26_1) { e_26 = { error: e_26_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_26) throw e_26.error; }
        }
        nodes = rootNode.getChildren();
        try {
            for (var nodes_2 = __values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
                var node = nodes_2_1.value;
                if (node instanceof babylonjs_1.TransformNode) {
                    this.applyLightmapsToNodeV1000(node);
                }
            }
        }
        catch (e_29_1) { e_29 = { error: e_29_1 }; }
        finally {
            try {
                if (nodes_2_1 && !nodes_2_1.done && (_d = nodes_2.return)) _d.call(nodes_2);
            }
            finally { if (e_29) throw e_29.error; }
        }
    };
    VFScene.prototype.findLightmapForNode = function (node, rootNode, callback) {
        var fixedPath = this.getPathForNode(node);
        var obj = this.model.getObjectAtPath(fixedPath);
        var uvs = null;
        var lightmapName = null;
        if (obj) {
            if (obj.lightmap != null && obj.lightmap > -1) {
                lightmapName = this.model.properties.lightmaps[obj.lightmap];
                uvs = obj.lightmap_uvs;
            }
        }
        else {
            var lm = this.model.getLightmapForObjectAt(fixedPath);
            lightmapName = lm["name"];
            uvs = lm["uvs"];
        }
        if (lightmapName) {
            var propString = [
                uvs.x.toString().substring(0, 10),
                uvs.y.toString().substring(0, 10),
                uvs.z.toString().substring(0, 10),
                uvs.w.toString().substring(0, 10),
            ].join("|");
            this.findOrLoadTexture(lightmapName + ".png", {}, propString, false, true, function (lightmap) {
                lightmap.level = 1.5;
                callback(lightmap);
            });
        }
    };
    VFScene.prototype.applyLightmapsToNodeV1100 = function (rootNode) {
        return __awaiter(this, void 0, void 0, function () {
            var rootPath, nodes, nodes_3, nodes_3_1, node, fixedPath, obj, resolvedNode, e_30_1, nodes_4, nodes_4_1, node, e_31_1;
            var e_30, _a, e_31, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        rootPath = this.getPathForNode(rootNode);
                        nodes = rootNode.getChildren();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, 7, 8]);
                        nodes_3 = __values(nodes), nodes_3_1 = nodes_3.next();
                        _c.label = 2;
                    case 2:
                        if (!!nodes_3_1.done) return [3, 5];
                        node = nodes_3_1.value;
                        if (!(node instanceof babylonjs_1.AbstractMesh)) return [3, 4];
                        node.name = node.name.split("_node")[0];
                        fixedPath = rootPath + "/" + node.name.replace(node.parent.name + ".", "");
                        obj = this.model.getObjectAtPath(fixedPath);
                        if (node.material) {
                            if (node.material["skipLightmap"] === true) {
                                return [3, 4];
                            }
                        }
                        if (!obj) return [3, 4];
                        if (!(obj.lightmap != null && obj.lightmap > -1)) return [3, 4];
                        resolvedNode = node;
                        if (node.isAnInstance) {
                            resolvedNode = this.createObjectForInstance(node, node.material);
                        }
                        return [4, this.applyLightmapToMeshV1100(resolvedNode, obj.lightmap, obj.lightmap_uv)];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        nodes_3_1 = nodes_3.next();
                        return [3, 2];
                    case 5: return [3, 8];
                    case 6:
                        e_30_1 = _c.sent();
                        e_30 = { error: e_30_1 };
                        return [3, 8];
                    case 7:
                        try {
                            if (nodes_3_1 && !nodes_3_1.done && (_a = nodes_3.return)) _a.call(nodes_3);
                        }
                        finally { if (e_30) throw e_30.error; }
                        return [7];
                    case 8:
                        nodes = rootNode.getChildren();
                        _c.label = 9;
                    case 9:
                        _c.trys.push([9, 14, 15, 16]);
                        nodes_4 = __values(nodes), nodes_4_1 = nodes_4.next();
                        _c.label = 10;
                    case 10:
                        if (!!nodes_4_1.done) return [3, 13];
                        node = nodes_4_1.value;
                        if (!(node instanceof babylonjs_1.TransformNode)) return [3, 12];
                        return [4, this.applyLightmapsToNodeV1100(node)];
                    case 11:
                        _c.sent();
                        _c.label = 12;
                    case 12:
                        nodes_4_1 = nodes_4.next();
                        return [3, 10];
                    case 13: return [3, 16];
                    case 14:
                        e_31_1 = _c.sent();
                        e_31 = { error: e_31_1 };
                        return [3, 16];
                    case 15:
                        try {
                            if (nodes_4_1 && !nodes_4_1.done && (_b = nodes_4.return)) _b.call(nodes_4);
                        }
                        finally { if (e_31) throw e_31.error; }
                        return [7];
                    case 16: return [2];
                }
            });
        });
    };
    VFScene.prototype.applyLightmapToMeshV1000 = function (mesh, lightmapName, lightmapObject) {
        return __awaiter(this, void 0, void 0, function () {
            var propString;
            var _this = this;
            return __generator(this, function (_a) {
                if (!(mesh.material instanceof babylonjs_1.PBRMaterial)) {
                    return [2];
                }
                propString = [
                    lightmapObject.uvs.x.toString().substring(0, 10),
                    lightmapObject.uvs.y.toString().substring(0, 10),
                    lightmapObject.uvs.z.toString().substring(0, 10),
                    lightmapObject.uvs.w.toString().substring(0, 10),
                ].join("|");
                this.findOrLoadTexture(lightmapName + ".png", {}, propString, false, true, function (lightmap) {
                    lightmap.level = 1.5;
                    var originalMaterial = mesh.material;
                    var vfMaterial = _this.getMaterialForName(originalMaterial.name);
                    var material = originalMaterial.clone(mesh.material.name + "_" + lightmapName);
                    lightmap.uScale = lightmapObject.uvs.x;
                    lightmap.vScale = lightmapObject.uvs.y;
                    lightmap.uOffset = lightmapObject.uvs.z;
                    lightmap.vOffset = lightmapObject.uvs.w;
                    lightmap.uAng = babylonjs_1.Tools.ToRadians(180);
                    lightmap.coordinatesIndex = 1;
                    material.useLightmapAsShadowmap = true;
                    material.lightmapTexture = lightmap;
                    mesh.material = material;
                    if (vfMaterial) {
                        vfMaterial.add(material);
                        _this._materialsByName[material.name] = vfMaterial;
                    }
                    if (originalMaterial.getBindedMeshes().length < 1) {
                        if (vfMaterial) {
                            vfMaterial.remove(originalMaterial);
                        }
                        originalMaterial.dispose(false, true);
                    }
                });
                return [2];
            });
        });
    };
    VFScene.prototype.applyLightmapToMeshV1100 = function (mesh, lightmapId, uvs) {
        var _this = this;
        if (!(mesh.material instanceof babylonjs_1.PBRMaterial)) {
            return;
        }
        if (lightmapId === 0 && uvs.x == null) {
            logger_1.default.error("invalid lightmap information", mesh);
            return;
        }
        var lightmapName = this.model.properties.lightmaps[lightmapId];
        var propString = [
            uvs.x.toString().substring(0, 10),
            uvs.y.toString().substring(0, 10),
            uvs.z.toString().substring(0, 10),
            uvs.w.toString().substring(0, 10),
        ].join("|");
        this.findOrLoadTexture(lightmapName + ".png", {}, propString, false, true, function (lightmap) {
            lightmap.level = 1.5;
            var originalMaterial = mesh.material;
            var vfMaterial = _this.getMaterialForName(originalMaterial.name);
            if (!vfMaterial) {
                logger_1.default.error("no material for " + originalMaterial.name, mesh.material);
            }
            if (originalMaterial["willLoadTexture"] > 0) {
                logger_1.default.error(originalMaterial.name + ": material is still loading textures... ");
            }
            var material = originalMaterial.clone(mesh.material.name + "_" + lightmapName);
            lightmap.uScale = uvs.x;
            lightmap.vScale = uvs.y;
            lightmap.uOffset = uvs.z;
            lightmap.vOffset = uvs.w;
            lightmap.uAng = babylonjs_1.Tools.ToRadians(180);
            lightmap.coordinatesIndex = 1;
            if (originalMaterial["lightmapIsTexture"] === true) {
                lightmap.hasAlpha = true;
                lightmap.getAlphaFromRGB = true;
                material.useAlphaFromAlbedoTexture = true;
                material.albedoTexture = lightmap;
                lightmap.coordinatesIndex = 0;
            }
            material.useLightmapAsShadowmap = true;
            material.lightmapTexture = lightmap;
            mesh.material = material;
            vfMaterial.add(material);
            _this._materialsByName[material.name] = vfMaterial;
            if (originalMaterial.getBindedMeshes().length < 1) {
                vfMaterial.remove(originalMaterial);
                originalMaterial.dispose(false, true);
            }
        });
    };
    VFScene.prototype.finalizeMeshes = function () {
        return __awaiter(this, void 0, void 0, function () {
            var meshes, meshes_4, meshes_4_1, mesh;
            var e_32, _a;
            return __generator(this, function (_b) {
                meshes = this.model.getMeshes();
                try {
                    for (meshes_4 = __values(meshes), meshes_4_1 = meshes_4.next(); !meshes_4_1.done; meshes_4_1 = meshes_4.next()) {
                        mesh = meshes_4_1.value;
                        this.prepareModelMesh(mesh);
                    }
                }
                catch (e_32_1) { e_32 = { error: e_32_1 }; }
                finally {
                    try {
                        if (meshes_4_1 && !meshes_4_1.done && (_a = meshes_4.return)) _a.call(meshes_4);
                    }
                    finally { if (e_32) throw e_32.error; }
                }
                return [2];
            });
        });
    };
    VFScene.prototype.optimizeScene = function () {
        var options = new babylonjs_2.SceneOptimizerOptions();
        options.addOptimization(new babylonjs_2.MergeMeshesOptimization(0));
        var optimizer = new babylonjs_2.SceneOptimizer(this, options);
        optimizer.start();
    };
    VFScene.prototype.getAllMeshes = function () {
        var e_33, _a, e_34, _b;
        var meshes = this.model.getMeshes();
        var allMeshes = new Array();
        try {
            for (var meshes_5 = __values(meshes), meshes_5_1 = meshes_5.next(); !meshes_5_1.done; meshes_5_1 = meshes_5.next()) {
                var mesh = meshes_5_1.value;
                allMeshes.push(mesh);
                if (mesh.hasInstances) {
                    try {
                        for (var _c = (e_34 = void 0, __values(mesh.instances)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var instance = _d.value;
                            allMeshes.push(instance);
                        }
                    }
                    catch (e_34_1) { e_34 = { error: e_34_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_34) throw e_34.error; }
                    }
                }
            }
        }
        catch (e_33_1) { e_33 = { error: e_33_1 }; }
        finally {
            try {
                if (meshes_5_1 && !meshes_5_1.done && (_a = meshes_5.return)) _a.call(meshes_5);
            }
            finally { if (e_33) throw e_33.error; }
        }
        return allMeshes;
    };
    VFScene.prototype.prepareModelMesh = function (mesh) {
        if (mesh.hasInstances) {
            mesh.alwaysSelectAsActiveMesh = true;
        }
        if (this.shadowGenerator) {
            if (!(mesh instanceof babylonjs_1.InstancedMesh)) {
                this.shadowGenerator.addShadowCaster(mesh, true);
                mesh.receiveShadows = true;
            }
        }
        if (this.mirrorTexture) {
            if (!(mesh instanceof babylonjs_1.InstancedMesh)) {
                this.mirrorTexture.renderList.push(mesh);
            }
        }
    };
    VFScene.prototype.finalizeTextures = function () {
        return __awaiter(this, void 0, void 0, function () {
            var uniqTextures, uniqTextureIds, usedTextureIds, removedTextures, allTextures, _a, _b, texture, _c, _d, material, pbrMaterial, oldTexture, newTexture, oldTexture, newTexture, oldTexture, newTexture, oldTexture;
            var e_35, _e, e_36, _f;
            return __generator(this, function (_g) {
                uniqTextures = {};
                uniqTextureIds = [];
                usedTextureIds = [];
                removedTextures = 0;
                allTextures = 0;
                try {
                    for (_a = __values(this.textures), _b = _a.next(); !_b.done; _b = _a.next()) {
                        texture = _b.value;
                        if (texture instanceof babylonjs_1.Texture) {
                            allTextures++;
                            if (texture.url == null) {
                                continue;
                            }
                            if (texture.url.includes(".glb")) {
                                continue;
                            }
                            if (uniqTextureIds.includes(texture.name)) {
                                continue;
                            }
                            uniqTextures[texture.name] = texture;
                            uniqTextureIds.push(texture.name);
                        }
                    }
                }
                catch (e_35_1) { e_35 = { error: e_35_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                    }
                    finally { if (e_35) throw e_35.error; }
                }
                try {
                    for (_c = __values(this.materials), _d = _c.next(); !_d.done; _d = _c.next()) {
                        material = _d.value;
                        if (material instanceof babylonjs_1.PBRMaterial) {
                            pbrMaterial = material;
                            if (pbrMaterial.albedoTexture != null) {
                                oldTexture = pbrMaterial.albedoTexture;
                                newTexture = uniqTextures[pbrMaterial.albedoTexture.name];
                                if (newTexture) {
                                    pbrMaterial.albedoTexture = newTexture;
                                    usedTextureIds.push(pbrMaterial.albedoTexture.uniqueId);
                                    if (oldTexture !== pbrMaterial.albedoTexture) {
                                        oldTexture.dispose();
                                        removedTextures++;
                                    }
                                }
                            }
                            if (pbrMaterial.bumpTexture != null) {
                                oldTexture = pbrMaterial.bumpTexture;
                                newTexture = uniqTextures[pbrMaterial.bumpTexture.name];
                                if (newTexture) {
                                    pbrMaterial.bumpTexture = newTexture;
                                    usedTextureIds.push(pbrMaterial.bumpTexture.uniqueId);
                                    if (oldTexture !== pbrMaterial.bumpTexture) {
                                        oldTexture.dispose();
                                        removedTextures++;
                                    }
                                }
                            }
                            if (pbrMaterial.emissiveTexture != null) {
                                oldTexture = pbrMaterial.emissiveTexture;
                                newTexture = uniqTextures[pbrMaterial.emissiveTexture.name];
                                if (newTexture) {
                                    pbrMaterial.emissiveTexture = newTexture;
                                    usedTextureIds.push(pbrMaterial.emissiveTexture.uniqueId);
                                    if (oldTexture !== pbrMaterial.emissiveTexture) {
                                        oldTexture.dispose();
                                        removedTextures++;
                                    }
                                }
                            }
                            if (pbrMaterial.environmentBRDFTexture != null) {
                                oldTexture = pbrMaterial.environmentBRDFTexture;
                                pbrMaterial.environmentBRDFTexture = uniqTextures[pbrMaterial.environmentBRDFTexture.name];
                                usedTextureIds.push(pbrMaterial.environmentBRDFTexture.uniqueId);
                                if (oldTexture !== pbrMaterial.environmentBRDFTexture) {
                                    oldTexture.dispose();
                                    removedTextures++;
                                }
                            }
                        }
                    }
                }
                catch (e_36_1) { e_36 = { error: e_36_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                    }
                    finally { if (e_36) throw e_36.error; }
                }
                logger_1.default.debug("Finalized Textures: " + removedTextures + " of " + allTextures + " Textures removed");
                return [2];
            });
        });
    };
    VFScene.prototype.getTextureUrl = function (name, path) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.model) {
                            return [2, name];
                        }
                        return [4, vf_asset_loader_1.default.requestAssetUrlFor(this, name, path)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    VFScene.prototype.loadTexture = function (name, canBeAlpha, canBeInverted, callback) {
        var _this = this;
        if (canBeAlpha === void 0) { canBeAlpha = true; }
        if (canBeInverted === void 0) { canBeInverted = false; }
        this.texturesToLoad += 1;
        logger_1.default.debug("Textures to Load++: " + this.texturesToLoad + " -> " + name);
        this.getTextureUrl(name, "auraweb/tex_" + this.player.config.playerResolution)
            .then(function (textureUrl) {
            if (!textureUrl) {
                throw new Error("can't get url for texture " + name);
            }
            var texture = new babylonjs_1.Texture(textureUrl, _this, false, canBeInverted, babylonjs_1.Texture.TRILINEAR_SAMPLINGMODE, function () {
                _this.texturesToLoad -= 1;
                callback(texture);
                logger_1.default.debug("Textures to Load--: " + _this.texturesToLoad + " -> " + texture.name);
            }, function (message, exception) {
                logger_1.default.error("Failed to load texture " + name, message, exception);
                _this.texturesToLoad -= 1;
            }, null, null, name.endsWith(".png") && canBeAlpha === true ? babylonjs_1.Engine.TEXTUREFORMAT_RGBA : babylonjs_1.Engine.TEXTUREFORMAT_RGB);
            texture.isBlocking = false;
            if (name.endsWith(".png") && canBeAlpha === true) {
                texture.hasAlpha = true;
            }
            texture.name = VFScene.getNormalizedTextureName(name);
        })
            .catch(function (error) {
            logger_1.default.error("failed to getTextureUrl: " + error);
            this.texturesToLoad -= 1;
        }.bind(this));
    };
    VFScene.getNormalizedTextureName = function (name) {
        return name.replace(".png", "").replace(".jpg", "");
    };
    VFScene.prototype.findOrLoadTexture = function (name, properties, propString, canBeAlpha, canBeInverted, callback) {
        if (propString === void 0) { propString = null; }
        if (canBeAlpha === void 0) { canBeAlpha = true; }
        if (canBeInverted === void 0) { canBeInverted = false; }
        var normalizedName = VFScene.getNormalizedTextureName(name);
        var foundTexture = this.getTextureWithName(normalizedName + (propString == null ? "" : " " + propString));
        if (foundTexture == null) {
            foundTexture = this.getTextureWithName(normalizedName);
            if (foundTexture instanceof babylonjs_1.Texture) {
                foundTexture = foundTexture.clone();
            }
        }
        if (foundTexture != null) {
            if (foundTexture instanceof babylonjs_1.Texture) {
                logger_1.default.info("reuse texture " + foundTexture.name + " url=" + foundTexture.url);
                if (properties.scale) {
                    foundTexture.uScale = properties.scale.x;
                    foundTexture.vScale = -properties.scale.y;
                }
                if (properties.offset) {
                    foundTexture.uOffset = properties.offset.x;
                    foundTexture.vOffset = -properties.offset.y;
                }
                foundTexture.uAng = babylonjs_1.Tools.ToRadians(180);
                callback(foundTexture);
                return;
            }
        }
        this.loadTexture(name, canBeAlpha, canBeInverted, function (loadedTexture) {
            loadedTexture.name += propString == null ? "" : " " + propString;
            if (properties.scale) {
                loadedTexture.uScale = properties.scale.x;
                loadedTexture.vScale = -properties.scale.y;
            }
            if (properties.offset) {
                loadedTexture.uOffset = properties.offset.x;
                loadedTexture.vOffset = -properties.offset.y;
            }
            loadedTexture.uAng = babylonjs_1.Tools.ToRadians(180);
            callback(loadedTexture);
        });
    };
    VFScene.prototype.getTextureWithName = function (name) {
        return this.textures.find(function (value) { return value.name === name; });
    };
    VFScene.prototype.getTextureUrlByHash = function (textureHash, defaultUrl) {
        if (textureHash === 0) {
            return defaultUrl;
        }
        if (this.model && this.model.hasProperties) {
            var textureName = this.model.properties["textures"][textureHash.toString()];
            var path = "auraweb/tex_" + this.player.config.playerResolution;
            return this.getTextureUrl(textureName, path);
        }
        return defaultUrl;
    };
    VFScene.prototype.setTextureForId = function (id, url, alpha) {
        var e_37, _a;
        if (alpha === void 0) { alpha = -1; }
        if (!this.model || !this.model.hasProperties) {
            logger_1.default.error("no properties in scene, cannot set texture");
            return;
        }
        if (!this.model.properties["components"]) {
            logger_1.default.error("no components in scene, cannot set texture");
            return;
        }
        if (this.model.formatVersion < 1100) {
            logger_1.default.error("scene format is outdated, cannot set texture");
            return;
        }
        if (!this._externalTextures) {
            var externalTextureParams = this.model.properties["components"].filter(function (component) {
                return component["component_type"].includes("ExternalTexture");
            });
            this._externalTextures = [];
            try {
                for (var externalTextureParams_1 = __values(externalTextureParams), externalTextureParams_1_1 = externalTextureParams_1.next(); !externalTextureParams_1_1.done; externalTextureParams_1_1 = externalTextureParams_1.next()) {
                    var params = externalTextureParams_1_1.value;
                    var externalTexture_1 = new vf_external_texture_1.default(this, params);
                    this._externalTextures.push(externalTexture_1);
                }
            }
            catch (e_37_1) { e_37 = { error: e_37_1 }; }
            finally {
                try {
                    if (externalTextureParams_1_1 && !externalTextureParams_1_1.done && (_a = externalTextureParams_1.return)) _a.call(externalTextureParams_1);
                }
                finally { if (e_37) throw e_37.error; }
            }
        }
        var externalTexture = this._externalTextures.find(function (ext) { return ext.objectPath === id; });
        if (!externalTexture) {
            logger_1.default.error("External Texture with id '" +
                id +
                "' not found, available textures are: " +
                this._externalTextures.map(function (ext) { return ext.objectPath; }).join("\n"));
            return;
        }
        externalTexture.loadFromUrl(url, alpha);
    };
    VFScene.prototype.setColorForMaterials = function (ids, color) {
        var e_38, _a;
        if (!this.model || !this.model.hasProperties) {
            logger_1.default.error("no properties in scene, cannot set material");
            return;
        }
        if (!this.model.properties["components"]) {
            logger_1.default.error("no components in scene, cannot set material");
            return;
        }
        if (this.model.formatVersion < 1100) {
            logger_1.default.error("scene format is outdated, cannot set material");
            return;
        }
        if (ids instanceof Array) {
            try {
                for (var ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                    var id = ids_1_1.value;
                    this.setColorForMaterial(id, color);
                }
            }
            catch (e_38_1) { e_38 = { error: e_38_1 }; }
            finally {
                try {
                    if (ids_1_1 && !ids_1_1.done && (_a = ids_1.return)) _a.call(ids_1);
                }
                finally { if (e_38) throw e_38.error; }
            }
        }
        else {
            this.setColorForMaterial(ids, color);
        }
    };
    VFScene.prototype.setColorForMaterial = function (id, color) {
        var material = this.getMaterialForName(id);
        if (!material) {
            logger_1.default.error("Material with id '" + id + "' not found");
            return;
        }
        material.setColor(babylonjs_1.Color3.FromHexString(color));
    };
    VFScene.prototype.getObjectForPath = function (path) {
        if (this._obectsByPath[path]) {
            return this._obectsByPath[path];
        }
        return null;
    };
    VFScene.prototype.getMeshesForMaterialById = function (id) {
        var material = this.materials.find(function (material) { return material.name === id; });
        if (material) {
            return material.getBindedMeshes();
        }
        return null;
    };
    VFScene.prototype.showObject = function (path) {
        var object = this.getObjectForPath(path);
        if (!object) {
            logger_1.default.error("Object with path '" +
                path +
                "' not found, available paths are: " +
                Object.keys(this._obectsByPath).join("\n"));
            return;
        }
        object.setActive(true);
    };
    VFScene.prototype.hideObject = function (path) {
        var object = this.getObjectForPath(path);
        if (!object) {
            logger_1.default.error("Object with path '" +
                path +
                "' not found, available paths are: " +
                Object.keys(this._obectsByPath).join("\n"));
            return;
        }
        object.setActive(false);
    };
    VFScene.prototype.onClickTrigger = function (trigger) {
        if (this.onClickTriggerObservable) {
            if (this.onClickTriggerObservable.hasObservers()) {
                this.onClickTriggerObservable.notifyObservers(trigger);
            }
        }
    };
    VFScene.prototype.triggerHovered = function (trigger) {
        if (this._hoveredTrigger !== trigger) {
            this._hoveredTrigger = trigger;
            this.didHoverTrigger(trigger.name, trigger.triggerType);
        }
    };
    VFScene.prototype.triggerUnhovered = function (trigger) {
        if (this._hoveredTrigger === trigger) {
            this.didHoverTrigger(null, null);
            this._hoveredTrigger = null;
        }
    };
    VFScene.prototype.getPathForNode = function (node) {
        var path = node.name.split("_node")[0];
        var currentMesh = node.parent;
        while (currentMesh != null) {
            path = currentMesh.name.split("_node")[0] + "/" + path;
            currentMesh = currentMesh.parent;
        }
        return path.replace("__root__/node0", "").replace("__root__/__root__", "");
    };
    VFScene.prototype.setupTriggers = function (modelMeta) {
        var e_39, _a;
        this.clearTriggers();
        if (this.setupTriggersFromModel(modelMeta)) {
            return;
        }
        if (modelMeta && modelMeta.triggers) {
            try {
                for (var _b = __values(modelMeta.triggers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var triggerMeta = _c.value;
                    var trigger = vf_trigger_factory_1.default.CreateTrigger(triggerMeta, triggerMeta, this);
                    if (trigger) {
                        var path = this.getPathForNode(trigger.pathNode);
                        this.triggers[trigger.name] = trigger;
                        this.triggersByPath[path] = trigger;
                        this.triggerMeshes.push(trigger.mesh);
                        trigger.setActive(false);
                        if (modelMeta.optionTriggerMapping != null &&
                            modelMeta.optionTriggerMapping.hasOwnProperty(trigger.name)) {
                            var optionTriggerMapping = modelMeta.optionTriggerMapping[trigger.name];
                            for (var key in optionTriggerMapping) {
                                switch (key) {
                                    case "visibility":
                                        trigger.setVisibility(optionTriggerMapping[key]);
                                        break;
                                    default:
                                        break;
                                }
                            }
                        }
                    }
                }
            }
            catch (e_39_1) { e_39 = { error: e_39_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_39) throw e_39.error; }
            }
        }
    };
    VFScene.prototype.showTriggers = function () {
        var e_40, _a;
        try {
            for (var _b = __values(Object.values(this.triggers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trigger = _c.value;
                if (trigger.getVisibility()) {
                    trigger.setActive(true);
                }
                else {
                    logger_1.default.info("Dispose trigger with name '" + trigger.name + "'.");
                    trigger.dispose();
                }
            }
        }
        catch (e_40_1) { e_40 = { error: e_40_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_40) throw e_40.error; }
        }
    };
    VFScene.prototype.registerTrigger = function (trigger) {
        var path = this.getPathForNode(trigger.pathNode);
        this.triggers[trigger.name] = trigger;
        this.triggersByPath[path] = trigger;
        this.triggerMeshes.push(trigger.mesh);
    };
    VFScene.prototype.unregisterTrigger = function (trigger) {
        var path = this.getPathForNode(trigger.pathNode);
        delete this.triggers[trigger.name];
        delete this.triggersByPath[path];
        this.triggerMeshes = this.triggerMeshes.filter(function (t) {
            return t !== trigger.mesh;
        });
    };
    VFScene.prototype.createNode = function (name) {
        var node = new babylonjs_1.AbstractMesh(name, this);
        node.parent = this.root;
        return node;
    };
    VFScene.prototype.setupTriggersFromModel = function (modelMeta) {
        var e_41, _a, e_42, _b;
        if (!this.model || !this.model.hasProperties) {
            return false;
        }
        if (!this.model.properties["triggers"]) {
            return false;
        }
        try {
            for (var _c = __values(this.model.properties["triggers"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                var triggerInfo = _d.value;
                if (this.triggers[triggerInfo["name"]] != null) {
                    continue;
                }
                var triggerName = triggerInfo["name"];
                if (modelMeta != null &&
                    modelMeta.optionTriggerMapping != null &&
                    modelMeta.optionTriggerMapping[triggerName] != null) {
                    if (modelMeta.optionTriggerMapping[triggerName].visibility === false) {
                        continue;
                    }
                }
                var triggerType = vf_trigger_meta_1.VFTriggerType.Unknown;
                if (triggerInfo["component_type"].includes("EventTrigger")) {
                    triggerType = vf_trigger_meta_1.VFTriggerType.Event;
                }
                if (triggerInfo["component_type"].includes("EgoTrigger")) {
                    triggerType = vf_trigger_meta_1.VFTriggerType.Ego;
                }
                var forwardsToTriggerHash = triggerInfo["forwards_to_trigger"] == null ? 0 : triggerInfo["forwards_to_trigger"];
                var forwardsToTriggerPath = null;
                if (forwardsToTriggerHash !== 0) {
                    try {
                        for (var _e = (e_42 = void 0, __values(this.model.properties["triggers"])), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var trigger_1 = _f.value;
                            if (trigger_1["target_object_id"] === forwardsToTriggerHash) {
                                forwardsToTriggerPath = trigger_1["path"];
                            }
                            else if (trigger_1["object"] === forwardsToTriggerHash) {
                                forwardsToTriggerPath = trigger_1["path"];
                            }
                        }
                    }
                    catch (e_42_1) { e_42 = { error: e_42_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_42) throw e_42.error; }
                    }
                }
                var customButtonTextureHash = 0;
                if (triggerInfo["custom_button_texture"] != null) {
                    customButtonTextureHash = triggerInfo["custom_button_texture"]["hash"];
                }
                var meta = {
                    name: triggerName,
                    type: triggerType,
                    enableScreenButton: true,
                    customButtonTextureHash: customButtonTextureHash,
                    forwardsToTrigger: forwardsToTriggerPath,
                    lookDirection: null,
                };
                if (triggerInfo.rotation) {
                    meta.lookDirection = triggerInfo.rotation.y;
                }
                if (triggerInfo.enable_screen_button) {
                    meta.enableScreenButton = triggerInfo["enable_screen_button"];
                }
                else {
                    meta.enableScreenButton = false;
                }
                var trigger = vf_trigger_factory_1.default.CreateTrigger(meta, triggerInfo, this);
                if (trigger) {
                    var path = this.getPathForNode(trigger.pathNode);
                    this.triggers[trigger.name] = trigger;
                    this.triggersByPath[path] = trigger;
                    this.triggerMeshes.push(trigger.mesh);
                    trigger.setActive(false);
                }
            }
        }
        catch (e_41_1) { e_41 = { error: e_41_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_41) throw e_41.error; }
        }
        return true;
    };
    VFScene.prototype.getTriggerType = function (triggerName) {
        if (this.model) {
            if (this.model.hasProperties) {
                if (this.model.properties["triggers"]) {
                    for (var triggerId in this.model.properties["triggers"]) {
                        var trigger = this.model.properties["triggers"][triggerId];
                        if (trigger["name"] === triggerName) {
                            if (trigger["component_type"].includes("EventTrigger")) {
                                return vf_trigger_meta_1.VFTriggerType.Event;
                            }
                            if (trigger["component_type"].includes("EgoTrigger")) {
                                return vf_trigger_meta_1.VFTriggerType.Ego;
                            }
                        }
                    }
                }
            }
        }
        return vf_trigger_meta_1.VFTriggerType.Unknown;
    };
    VFScene.prototype.activateTrigger = function (pathOrName, byCode) {
        if (byCode === void 0) { byCode = false; }
        var trigger = this.triggersByPath[pathOrName];
        if (trigger == null) {
            trigger = this.triggers[pathOrName];
        }
        if (trigger != null) {
            trigger.onClick(byCode);
        }
        else {
            logger_1.default.warn("trigger not found: " +
                pathOrName +
                " available paths are: " +
                Object.keys(this.triggersByPath).join("\n"));
        }
    };
    VFScene.prototype.registerTriggerCallback = function (triggerName, callback) {
        var trigger = this.triggers ? this.triggers[triggerName] : null;
        if (trigger && trigger instanceof vf_event_trigger_1.default) {
            trigger.registerCallback(callback);
        }
        else {
            throw "event trigger with name " + triggerName + " does not exist";
        }
    };
    VFScene.LookRotation = function (from, to) {
        var result = babylonjs_1.Matrix.Zero();
        babylonjs_1.Matrix.LookAtLHToRef(from, to, new babylonjs_1.Vector3(0, 1, 0), result);
        result.invert();
        return babylonjs_1.Quaternion.FromRotationMatrix(result);
    };
    VFScene.prototype.onEgoInit = function (position, targetRotation) {
        var e_43, _a;
        if (targetRotation === void 0) { targetRotation = null; }
        this.egoCamera.setEnabled(true);
        this.egoCamera.position.copyFrom(this.camera.position);
        this.egoCamera.rotationQuaternion = this.camera.absoluteRotation;
        var fov = this.egoCamera.fov;
        this.egoCamera.fov = this.camera.fov;
        if (targetRotation == null) {
            targetRotation = VFScene.LookRotation(this.camera.position, new babylonjs_1.Vector3(position.x, this.camera.position.y, position.z));
        }
        if (!this.egoCamera) {
            logger_1.default.warn("ego perspective mode is not supported for this scene");
            return;
        }
        this.stopAutorotate();
        this.camera.setEnabled(false);
        this.camera.storeState();
        this.activeCamera = this.egoCamera;
        this.camera.detachControl(this.getEngine().getRenderingCanvas());
        this.egoCamera.attachControl(this.getEngine().getRenderingCanvas());
        this.state = vf_scene_state_1.VFSceneState.EgoPerspective;
        try {
            for (var _b = __values(this.onEgoInitCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                var callback = _c.value;
                callback();
            }
        }
        catch (e_43_1) { e_43 = { error: e_43_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_43) throw e_43.error; }
        }
        vf_ego_camera_1.default.EASE_MODE.setEasingMode(babylonjs_1.EasingFunction.EASINGMODE_EASEINOUT);
        if (vf_ego_camera_1.default.SkipsNextEgoTransition) {
            this.egoCamera.fov = fov;
            this.egoCamera.rotationQuaternion = targetRotation;
            this.egoCamera.moveTo(position, targetRotation);
            return;
        }
        babylonjs_1.Animation.CreateAndStartAnimation("at5", this.egoCamera, "fov", 30, 30, this.egoCamera.fov, fov, 0, vf_ego_camera_1.default.EASE_MODE);
        babylonjs_1.Animation.CreateAndStartAnimation("at5", this.egoCamera, "rotationQuaternion", 60, 60, this.egoCamera.rotationQuaternion, targetRotation, 0, vf_ego_camera_1.default.EASE_MODE);
        this.egoCamera.moveTo(position, targetRotation);
    };
    VFScene.prototype.onEgoExit = function () {
        var _this = this;
        var ease = new babylonjs_1.CubicEase();
        ease.setEasingMode(babylonjs_1.EasingFunction.EASINGMODE_EASEINOUT);
        var position = this.camera.position;
        var fov = this.camera.fov;
        var quat = this.camera.absoluteRotation;
        babylonjs_1.Animation.CreateAndStartAnimation("at5", this.egoCamera, "fov", 30, 30, this.egoCamera.fov, fov, 0, ease);
        this.egoCamera.moveTo(position, quat, function () {
            var e_44, _a;
            _this.camera.setEnabled(true);
            _this.activeCamera = _this.camera;
            _this.egoCamera.setEnabled(false);
            _this.camera.restoreState();
            _this.camera.attachControl(_this.getEngine().getRenderingCanvas());
            _this.egoCamera.detachControl(_this.getEngine().getRenderingCanvas());
            _this.state = vf_scene_state_1.VFSceneState.Default;
            try {
                for (var _b = __values(_this.onEgoExitCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback();
                }
            }
            catch (e_44_1) { e_44 = { error: e_44_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_44) throw e_44.error; }
            }
            _this.startAutorotate();
        });
    };
    VFScene.prototype.registerOnEgoExitCallback = function (callback) {
        this.onEgoExitCallbacks.push(callback);
    };
    VFScene.prototype.registerDidActivateTriggerCallback = function (callback) {
        this.onTriggerActivateCallbacks.push(callback);
    };
    VFScene.prototype.registerDidHoverTriggerCallback = function (callback) {
        this.onTriggerHoverCallbacks.push(callback);
    };
    VFScene.prototype.registerOnEgoInitCallback = function (callback) {
        this.onEgoInitCallbacks.push(callback);
    };
    VFScene.prototype.onARInit = function () {
        this.activeCamera.storeState();
        this.unfreeze();
        this.setGroundEnabled(false);
        this.model.scaleToSize(const_1.default.AR_SCALE);
        this.state = vf_scene_state_1.VFSceneState.EgoPerspective;
    };
    VFScene.prototype.onARExit = function () {
        this.setGroundEnabled(true);
        this.freeze();
        this.state = vf_scene_state_1.VFSceneState.Default;
    };
    VFScene.prototype.setScale = function (scale) {
        if (!this._originalScale) {
            this._originalScale = this.root.scaling;
        }
        this.root.scaling = this._originalScale.scale(scale);
    };
    VFScene.prototype.setFlip = function (x, y, z) {
        if (!this._originalScale) {
            this._originalScale = this.root.scaling;
        }
        this.root.scaling = this._originalScale.multiplyByFloats(x ? -1 : 1, y ? -1 : 1, z ? -1 : 1);
    };
    VFScene.prototype.setPositioning = function (x, y, z) {
        this._positioningX = x;
        this._positioningY = y;
        this._positioningZ = z;
        this.updatePositioning();
        this.updateTransform();
    };
    VFScene.prototype.updatePositioning = function () {
        if (!this._originalPositioning) {
            this._originalPositioning = babylonjs_1.Vector3.Zero();
        }
        if (this._positioningX === "ORIGINAL") {
            this._originalPositioning.x = 0;
        }
        else if (this._positioningX === "CENTER") {
            this._originalPositioning.x = -this.root._boundingInfo.boundingBox.center.x;
        }
        else if (this._positioningX === "MAXIMUM") {
            this._originalPositioning.x = -this.root._boundingInfo.boundingBox.minimum.x;
        }
        else if (this._positioningX === "MINIMUM") {
            this._originalPositioning.x = -this.root._boundingInfo.boundingBox.maximum.x;
        }
        if (this._positioningY === "ORIGINAL") {
            this._originalPositioning.y = 0;
        }
        else if (this._positioningY === "CENTER") {
            this._originalPositioning.y = -this.root._boundingInfo.boundingBox.center.y;
        }
        else if (this._positioningY === "MAXIMUM") {
            this._originalPositioning.y = -this.root._boundingInfo.boundingBox.minimum.y;
        }
        else if (this._positioningY === "MINIMUM") {
            this._originalPositioning.y = -this.root._boundingInfo.boundingBox.maximum.y;
        }
        if (this._positioningZ === "ORIGINAL") {
            this._originalPositioning.z = 0;
        }
        else if (this._positioningZ === "CENTER") {
            this._originalPositioning.z = -this.root._boundingInfo.boundingBox.center.z;
        }
        else if (this._positioningZ === "MAXIMUM") {
            this._originalPositioning.z = -this.root._boundingInfo.boundingBox.minimum.z;
        }
        else if (this._positioningZ === "MINIMUM") {
            this._originalPositioning.z = -this.root._boundingInfo.boundingBox.maximum.z;
        }
    };
    VFScene.prototype.setOffset = function (x, y, z) {
        this._offset = new babylonjs_1.Vector3(x, y, z);
        this.updateTransform();
    };
    VFScene.prototype.setRotate = function (x, y, z) {
        this._rotate = new babylonjs_1.Vector3(babylonjs_1.Tools.ToRadians(x), babylonjs_1.Tools.ToRadians(y), babylonjs_1.Tools.ToRadians(z));
        this.updateTransform();
    };
    VFScene.prototype.updateTransform = function () {
        if (!this._originalPositioning) {
            this._originalPositioning = babylonjs_1.Vector3.Zero();
        }
        if (!this._rotationNode) {
            this._rotationNode = new babylonjs_1.TransformNode("rotation", this);
            this.root.setParent(this._rotationNode);
        }
        if (!this._positionNode) {
            this._positionNode = new babylonjs_1.TransformNode("offset", this);
            this._rotationNode.setParent(this._positionNode);
        }
        this._rotationNode.rotationQuaternion = babylonjs_1.Quaternion.FromEulerVector(this._rotate);
        this.root.position = this._originalPositioning;
        this._positionNode.position = this._offset;
    };
    VFScene.prototype.setGroundEnabled = function (enabled) {
        if (this.environment && this.environment.ground) {
            this.environment.ground.setEnabled(enabled);
        }
    };
    VFScene.prototype.freeze = function () {
        if (this.shadowGenerator) {
            this.shadowGenerator.getShadowMap().refreshRate = babylonjs_1.RenderTargetTexture.REFRESHRATE_RENDER_ONCE;
        }
        if (this.model) {
            this.model.freeze();
        }
        this.blockMaterialDirtyMechanism = true;
        logger_1.default.debug("scene.freeze");
    };
    VFScene.prototype.createObjectForInstance = function (mesh, material, includeChilds) {
        if (includeChilds === void 0) { includeChilds = true; }
        var iMesh = mesh;
        var newMesh = iMesh.sourceMesh.clone(mesh.name, mesh.parent, !includeChilds);
        newMesh.position = mesh.position;
        newMesh.rotationQuaternion = mesh.rotationQuaternion;
        newMesh.scaling = mesh.scaling;
        newMesh.material = material;
        newMesh.name = mesh.name;
        newMesh.renderingGroupId = mesh.renderingGroupId;
        mesh.dispose();
        return newMesh;
    };
    VFScene.prototype.unfreeze = function () {
        if (this.shadowGenerator) {
            this.shadowGenerator.getShadowMap().refreshRate = babylonjs_1.RenderTargetTexture.REFRESHRATE_RENDER_ONEVERYTWOFRAMES;
        }
        if (this.model) {
            this.model.unfreeze();
        }
        this.blockMaterialDirtyMechanism = false;
        logger_1.default.debug("scene.unfreeze");
    };
    VFScene.prototype.resizeTriggerMeshes = function (scale) {
        var e_45, _a;
        try {
            for (var _b = __values(Object.values(this.triggers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var trigger = _c.value;
                trigger.setScale(scale);
            }
        }
        catch (e_45_1) { e_45 = { error: e_45_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_45) throw e_45.error; }
        }
    };
    VFScene.prototype.clearMeshes = function () {
        vf_material_factory_1.default.reset();
        vf_asset_loader_1.default.reset();
        if (this.model) {
            this.model.dispose();
        }
        if (this.shadowGenerator) {
            this.shadowGenerator.getShadowMap().renderList = [];
        }
        if (this.mirrorTexture) {
            this.mirrorTexture.renderList = [];
        }
        this.model = null;
    };
    VFScene.prototype.clearTriggers = function () {
        for (var triggerName in this.triggers) {
            this.triggers[triggerName].dispose();
        }
        this.triggers = {};
        this.triggersByPath = {};
        this.triggerMeshes = new Array();
    };
    VFScene.prototype.dispose = function () {
        this.clearMeshes();
        this.clearTriggers();
        _super.prototype.dispose.call(this);
        this.player.engine.stopRenderLoop();
    };
    Object.defineProperty(VFScene.prototype, "sceneState", {
        get: function () {
            return this.state;
        },
        enumerable: true,
        configurable: true
    });
    return VFScene;
}(babylonjs_1.Scene));
exports.default = VFScene;
